import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { useField } from "react-final-form";
import { FileInput } from "@vk-hr-tek/ui/input";
import { composeValidators } from "../validation/index.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function FileInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else FileInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const FileInput_FileInput = (t0)=>{
    const $ = c(33);
    const { label, labelIcon, tooltip, name, variant: t1, placeholder, required: t2, disabled: t3, onChange, loading: t4, loadingText: t5, validate, cache, fullWidth, bannerText, autorecognitionQr: t6, helperText, error: errorOverride, errorText: errorTextOverride, testId, withAuth, withZoom: t7, validationWithoutTouch: t8, validationWhenDisabled: t9 } = t0;
    const variant = void 0 === t1 ? "input" : t1;
    const required = void 0 === t2 ? false : t2;
    const disabled = void 0 === t3 ? false : t3;
    const loading = void 0 === t4 ? false : t4;
    const loadingText = void 0 === t5 ? void 0 : t5;
    const autorecognitionQr = void 0 === t6 ? false : t6;
    const withZoom = void 0 === t7 ? false : t7;
    const validationWithoutTouch = void 0 === t8 ? false : t8;
    const validationWhenDisabled = void 0 === t9 ? false : t9;
    let t10;
    if ($[0] !== validate) {
        t10 = validate || [];
        $[0] = validate;
        $[1] = t10;
    } else t10 = $[1];
    let t11;
    if ($[2] !== t10) {
        t11 = composeValidators(t10);
        $[2] = t10;
        $[3] = t11;
    } else t11 = $[3];
    const validators = t11;
    let t12;
    if ($[4] !== validators) {
        t12 = {
            validate: validators
        };
        $[4] = validators;
        $[5] = t12;
    } else t12 = $[5];
    const { input, meta } = useField(name, t12);
    const { onChange: onChangeInput, onBlur } = input;
    const errorDisabled = disabled || !validationWhenDisabled;
    const renderError = !errorDisabled && validationWithoutTouch ? !!input.value && !!meta.error : meta.touched && meta.error;
    let t13;
    if ($[6] !== onChange || $[7] !== onChangeInput) {
        t13 = (props)=>{
            onChangeInput(props);
            null == onChange || onChange(props);
        };
        $[6] = onChange;
        $[7] = onChangeInput;
        $[8] = t13;
    } else t13 = $[8];
    const t14 = errorOverride || renderError;
    const t15 = errorTextOverride || renderError && meta.error;
    let t16;
    if ($[9] !== autorecognitionQr || $[10] !== bannerText || $[11] !== cache || $[12] !== disabled || $[13] !== fullWidth || $[14] !== helperText || $[15] !== input || $[16] !== label || $[17] !== labelIcon || $[18] !== loading || $[19] !== loadingText || $[20] !== onBlur || $[21] !== placeholder || $[22] !== required || $[23] !== t13 || $[24] !== t14 || $[25] !== t15 || $[26] !== testId || $[27] !== tooltip || $[28] !== validators || $[29] !== variant || $[30] !== withAuth || $[31] !== withZoom) {
        t16 = /*#__PURE__*/ jsx(FileInput, _object_spread_props(_object_spread({}, input), {
            label: label,
            labelIcon: labelIcon,
            value: input.value,
            onChange: t13,
            variant: variant,
            tooltip: tooltip,
            required: required,
            error: t14,
            errorText: t15,
            helperText: helperText,
            disabled: disabled,
            loading: loading,
            loadingText: loadingText,
            onBlur: onBlur,
            cache: cache,
            fullWidth: fullWidth,
            placeholder: placeholder,
            autorecognitionQr: autorecognitionQr,
            bannerText: bannerText,
            testId: testId,
            withZoom: withZoom,
            validators: validators,
            withAuth: withAuth
        }));
        $[9] = autorecognitionQr;
        $[10] = bannerText;
        $[11] = cache;
        $[12] = disabled;
        $[13] = fullWidth;
        $[14] = helperText;
        $[15] = input;
        $[16] = label;
        $[17] = labelIcon;
        $[18] = loading;
        $[19] = loadingText;
        $[20] = onBlur;
        $[21] = placeholder;
        $[22] = required;
        $[23] = t13;
        $[24] = t14;
        $[25] = t15;
        $[26] = testId;
        $[27] = tooltip;
        $[28] = validators;
        $[29] = variant;
        $[30] = withAuth;
        $[31] = withZoom;
        $[32] = t16;
    } else t16 = $[32];
    return t16;
};
export { FileInput_FileInput as FileInput };
